import { Ass_01, Exp_01 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const HOME_OFFICE_RENOVATION: Template = {
  id: "449232a1-5db0-49f3-be88-e90d59fa5ad3",
  name: "Kodukontori renoveerimine kassast",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Kodukontori renoveerimine (30%)"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Renoveerimise kompensatsioon",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Exp_01,
          credit: Ass_01
        }
      ]
    };

    return { type: "success", entry };
  }
};
